export { Horizontal as CardHorizontal } from './Horizontal'
export { Vertical as CardVertical } from './Vertical'

export const CARD_ACTION_COLORS = {
    DEFAULT: '#1855B7',
    SUCCESS: '#35E712',
    WARNING: '#EBAB34',
    DANGER: '#FF4400',
    DISABLED: '#CCCCCC',
}